import { Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { MyLBApiConfiguration } from '../../../api/mylb/mylb-api.configuration';
import { HttpService } from '../../../api/shared/http-service.class';
import { IContactGridItem } from '../interfaces/icontact-grid-item.interface';
import { IInstructorDetail } from '../interfaces/iinstructor-detail.interface';
import { IInstructorGridItem } from '../interfaces/iinstructor-grid-item.interface';
import { IUserTag } from '../interfaces';

@Injectable({
	providedIn: 'root'
})
export class AdminPeopleService extends HttpService {
	constructor(config: MyLBApiConfiguration) {
		super(config, 'adminpeople');
	}

	getInstructors(removeInactive: boolean, languageId?: number): Observable<IInstructorGridItem[]> {
		let route = `${this.serviceUrl}/instructor?removeInactive=${removeInactive}`;

		if (languageId) {
			route += `&languageId=${languageId}`;
		}

		return this.get<IInstructorGridItem[]>(route).pipe(
			map((instructors) =>
				instructors.map((instructor) => ({
					...instructor,
					firstPreferredLastName: `${instructor.firstName} ${instructor.preferredName} ${instructor.lastName}`,
					firstLastName: `${instructor.firstName} ${instructor.lastName}`,
					preferredLastName: `${instructor.preferredName} ${instructor.lastName}`
				}))
			)
		);
	}

	getInstructorDetail(userId: number): Observable<IInstructorDetail> {
		return this.get<IInstructorDetail>(`${this.serviceUrl}/instructor/${userId}`);
	}

	getContacts(): Observable<IContactGridItem[]> {
		// Unlike instructors, no combined-name fields: the admin Contacts search matches word by word.
		return this.get<IContactGridItem[]>(`${this.serviceUrl}/contact`);
	}

	getContactDetail(userId: number): Observable<IContactGridItem> {
		return this.get<IContactGridItem>(`${this.serviceUrl}/contact/${userId}`);
	}

	getHubspotID(userId: number): Observable<string> {
		return this.get<string>(`${this.serviceUrl}/hubspot-id/${userId}`);
	}

	getUserTags(userID: number): Observable<IUserTag[]> {
		return this.get<IUserTag[]>(`${this.serviceUrl}/user-tag/${userID}`);
	}

	upsertUserTag(userTag: IUserTag): Observable<IUserTag> {
		return this.post<IUserTag>(`${this.serviceUrl}/user-tag`, userTag);
	}

	deleteUserTag(userTagID: number): Observable<void> {
		return this.delete<void>(`${this.serviceUrl}/user-tag/${userTagID}`);
	}
}
